// スタンプラリーの期間(弾)フィルタ判定・口数計算。
// events/show.js の StampRallySection と shared/stamp_rally_popup.js で共有する。

// 口数計算。Ruby 側の EventStampEntry.compute_tickets と同ロジック。
// material_download と seminar_view は 3件で 1口、upsell_consultation / monitor_apply / referral_registration は 1件で 1口。
export const computeTickets = (entries) => {
  const count = (t) => entries.filter((e) => e.action_type === t).length;
  return (
    Math.floor(count("material_download") / 3) +
    Math.floor(count("seminar_view") / 3) +
    count("upsell_consultation") +
    count("monitor_apply") +
    count("referral_registration")
  );
};

// 期間に含まれるか判定。start_on = その日の 00:00:00、end_on = その日の 23:59:59.999 まで含む。
export const isEntryInPhase = (entry, phase) => {
  const t = new Date(entry.created_at).getTime();
  const s = phase.start_on ? new Date(`${phase.start_on}T00:00:00`).getTime() : -Infinity;
  const e = phase.end_on ? new Date(`${phase.end_on}T23:59:59.999`).getTime() : Infinity;
  return t >= s && t <= e;
};

// 期間がタイトル/開始日/終了日が揃っていない場合でも、設定された情報でフィルタ判定を行う。
export const phaseContainsNow = (phase) => {
  const now = Date.now();
  const s = phase.start_on ? new Date(`${phase.start_on}T00:00:00`).getTime() : -Infinity;
  const e = phase.end_on ? new Date(`${phase.end_on}T23:59:59.999`).getTime() : Infinity;
  return now >= s && now <= e;
};

// 表示すべきデフォルトの期(phase)のインデックス。
// 2件未満なら先頭固定。2件以上なら「今」を含む期を優先し、無ければ先頭。
export const pickDefaultPhaseIndex = (phases) => {
  if (phases.length < 2) return 0;
  const idx = phases.findIndex(phaseContainsNow);
  return idx >= 0 ? idx : 0;
};
